<div class="row">
  <div class="col-md-3 pb-4" *ngFor="let paymentProvider of paymentProviders">
    <div class="art-box payment" [class.selected]="isSelected(paymentProvider)"
      [class.disabled]="paymentProvider.disabled"
      (click)="onSelectProvider(paymentProvider)">
      <div>
        <fa-icon *ngIf="getIcon(paymentProvider) !== null && !getImageUrl(paymentProvider)" class="icon-style"
          [icon]="getIcon(paymentProvider)"></fa-icon>
        <img *ngIf="getImageUrl(paymentProvider) !== ''" [attr.src]="getImageUrl(paymentProvider)">
        <h3 *ngIf="showProviderName(paymentProvider)">{{ getProviderName(paymentProvider) | translate }}</h3>
      </div>
    </div>
  </div>
</div>
